/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_ScopesInputs */

const en_entity_scopes = /** @type {(inputs: Entity_ScopesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopes`)
};

const de_entity_scopes = /** @type {(inputs: Entity_ScopesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopes`)
};

/**
* | output |
* | --- |
* | "Scopes" |
*
* @param {Entity_ScopesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_scopes = /** @type {((inputs?: Entity_ScopesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_ScopesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_scopes(inputs)
	return de_entity_scopes(inputs)
});